export const LIST_GRILLE_SUCCESS = "LIST_GRILLE_SUCCESS"
export const LIST_GRILLE_FAIL = "LIST_GRILLE_FAIL"

export const CREATEGRILLE_SUCCESS = "CREATEGRILLE_SUCCESS"
export const CREATEGRILLE_FAIL = "CREATEGRILLE_FAIL"
export const OPEN_GRILLE_SUCCESS = "OPEN_GRILLE_SUCCESS"

export const UPDATE_GRILLE_SUCCESS = "UPDATEGRILLE_SUCCESS"
export const UPDATE_GRILLE_FAIL = "UPDATEGRILLE_FAIL"

export const ONE_GRILLE_SUCCESS = "ONE_GRILLE_SUCCESS"
export const ONE_GRILLE_FAIL = "ONE_GRILLE_FAIL"

export const DEACTIVATE_GRILLE_SUCCESS = "DEACTIVATE_GRILLE_SUCCESS"
export const DEACTIVATE_GRILLE_FAIL = "DEACTIVATE_GRILLE_FAIL"

export const LIST_GRILLE_Desactiver_SUCCESS = "LIST_GRILLE_Desactiver_SUCCESS"
export const LIST_GRILLE_Desactiver_FAIL = "LIST_GRILLE_Desactiver_FAIl"

export const SEARCH_GRILLE_SUCCESS = "SEARCH_GRILLE_SUCCESS";
export const SEARCH_GRILLE_FAIL = "SEARCH_GRILLE_FAIL";

export const REMOVE_CRITERIA_VALUES_SUCCESS = "REMOVE_CRITERIA_VALUES_SUCCESS";
export const REMOVE_CRITERIA_VALUES_FAIL = "REMOVE_CRITERIA_VALUES_FAIL";

export const CLEAR_DATA_GRILLE   = "CLEAR_DATA_GRILLE";
export const LIST_GRIDS_SUCCESS  = "LIST_GRIDS_SUCCESS";
export const LIST_All_GRIDS_FAIL = "LIST_All_GRIDS_FAIL" ;